import { createSlice } from "@reduxjs/toolkit";
import { deleteDriver } from "../thunks/deleteDriverThunk";

const deleteDriverSlice = createSlice({
  name: "driver",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
    message: null,
  },
  reducers: {
    resetDriverDeleteStatus: (state) => {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteDriver.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deleteDriver.fulfilled, (state, action) => {
        state.message = action.payload.msg;
        state.status = "success";
        state.error = null;
      })
      .addCase(deleteDriver.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetDriverDeleteStatus } = deleteDriverSlice.actions;
export default deleteDriverSlice.reducer;
